import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { getAgentUserProfile, getRequirementByRecruiterId } from "../../../../endpoints/hiringCompany/requirements";
import ChatList from "../../../MessagesPage/components/ChatList";

export default function Messages() {
  const { agentId } = useParams();
  const [search, setSearch] = useSearchParams();
  const [requirements, setRequirements] = useState<any[]>([]);
  const [agent, setAgent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const selectedId = search.get("requirementId") || "";
  const requirement = requirements.find(item => item._id === selectedId);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    setRequirements([]);
    setAgent(null);
    Promise.all([getRequirementByRecruiterId(agentId), getAgentUserProfile(agentId)])
      .then(([shared, profile]) => {
        if (cancelled) return;
        if (!shared.success || !profile.success) throw new Error("Unable to load shared requirements");
        setRequirements(shared.data || []);
        setAgent(profile.data);
      }).catch(error => {
        if (!cancelled) setError(error?.message || "Unable to load shared requirements");
      }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [agentId]);

  if (loading) return <p className="p-6 text-sm">Loading shared requirements...</p>;
  if (error) return <p role="alert" className="p-6 text-sm">{error}</p>;

  const name = [agent?.firstName, agent?.lastName].filter(Boolean).join(" ") || agent?.companyName || "Recruitment agent";
  const conversationKey = requirement ? `requirement:${requirement._id}` : "";
  const contact: any = requirement ? {
    _id: conversationKey, jobId: conversationKey, jobTitle: requirement.title,
    participantDetails: { _id: agentId, userId: agentId, name, profilePic: agent?.profilePic,
      companyName: agent?.companyName, referenceId: agent?.refNo },
  } : null;

  return <section className="flex flex-col flex-1 min-h-0 pt-5" aria-label="Partner agency messages">
    <div className="flex flex-wrap items-center gap-4 rounded-md bg-[#F1F5F9] px-4 py-3 mb-3">
      <div className="text-sm font-semibold">{name}{agent?.companyName ? ` - ${agent.companyName}` : ""}</div>
      <label className="flex flex-col gap-1 text-xs ml-auto">
        Shared job requirement
        <select aria-label="Shared job requirement" value={requirement ? selectedId : ""}
          className="rounded border bg-white px-3 py-2 min-w-64" onChange={event => {
            const next = new URLSearchParams(search);
            if (event.target.value) next.set("requirementId", event.target.value);
            else next.delete("requirementId");
            setSearch(next, { replace: true });
          }}>
          <option value="">Select a shared requirement</option>
          {requirements.map(item => <option key={item._id} value={item._id}>{item.title}{item.refNo ? ` - ${item.refNo}` : ""}</option>)}
        </select>
      </label>
    </div>
    {requirement ? <ChatList key={`${agentId}:${conversationKey}`} selectedContact={contact} />
      : <p className="p-6 text-sm text-gray-500">{requirements.length
        ? "Select a shared job requirement to start or continue this conversation."
        : "No job requirements have been shared with this recruitment agent yet."}</p>}
  </section>;
}
